import SalesPersonByMonthPreview from "./SalesPersonByMonthPreview";

const PrintSalesPersonByMonth: React.FC = () => {
  return (
    <div className="inner-container">
      <SalesPersonByMonthPreview />
    </div>
  );
};

export default PrintSalesPersonByMonth;
